import './Header.css';

function Header() {
  return (
    <header className="header">
      <h1>URGENT REPORT</h1>
      <hr />
    </header>
  );
}

export default Header;
